import { render, staticRenderFns } from "./HelloWorld.vue?vue&type=template&id=392a8d61&shadow"
import script from "./HelloWorld.vue?vue&type=script&lang=js&shadow"
export * from "./HelloWorld.vue?vue&type=script&lang=js&shadow"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports